// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: vehicle/planner/lcmtypes/movement.lcm

import { float } from "@skydio/lcm/src/types";
import { int64_t } from "@skydio/lcm/src/types";
import { movement_waypoint_t } from "../planner/movement_waypoint_t";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class spatial_waypoints_command_t extends LcmMsg {

  private static _hash = Long.fromString("13064857351715968202", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (spatial_waypoints_command_t._packed_fingerprint === undefined) {
      spatial_waypoints_command_t._packed_fingerprint = spatial_waypoints_command_t._get_hash_recursive([]);
    }
    return spatial_waypoints_command_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(spatial_waypoints_command_t) > -1) {
      return Long.fromNumber(0, true);
    }
    const new_parents = parents.concat([spatial_waypoints_command_t]);
    let tmp_hash = spatial_waypoints_command_t._hash;
    tmp_hash = tmp_hash.add(movement_waypoint_t._get_hash_recursive(new_parents));
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    creation_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    sample_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    position_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    velocity_aggressiveness: { kind: "primitive", type: Number, typeStr: "float" },
    max_acceleration: { kind: "primitive", type: Number, typeStr: "float" },
    spatial_waypoints: { kind: "array", dims: [{ kind: "auto" }], nDim: 1, inner: { kind: "struct", type: movement_waypoint_t, typeStr: "movement_waypoint_t" } },
  };

  public creation_utime: int64_t;
  public sample_utime: int64_t;
  public position_aggressiveness: float;
  public velocity_aggressiveness: float;
  public max_acceleration: float;
  public spatial_waypoints: movement_waypoint_t[];

  public override decode(byte_array: Uint8Array): spatial_waypoints_command_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(spatial_waypoints_command_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, spatial_waypoints_command_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): spatial_waypoints_command_t {
    this.creation_utime = decoder.decode_int64_t();
    this.sample_utime = decoder.decode_int64_t();
    this.position_aggressiveness = decoder.decode_float();
    this.velocity_aggressiveness = decoder.decode_float();
    this.max_acceleration = decoder.decode_float();
    const v_num_spatial_waypoints = decoder.decode_int32_t();
    this.spatial_waypoints = new Array(v_num_spatial_waypoints);
    for (let i0 = 0; i0 < v_num_spatial_waypoints; i0++) {
      this.spatial_waypoints[i0]! = new movement_waypoint_t().decode_one(decoder);
    }
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += 8;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    const v_num_spatial_waypoints = this.spatial_waypoints.length;
    total_size += 4;
    for (let i0 = 0; i0 < v_num_spatial_waypoints; i0++) {
      total_size += this.spatial_waypoints[i0]!._get_encoded_size();
    }
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(spatial_waypoints_command_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int64_t(this.creation_utime);
    encoder.encode_int64_t(this.sample_utime);
    encoder.encode_float(this.position_aggressiveness);
    encoder.encode_float(this.velocity_aggressiveness);
    encoder.encode_float(this.max_acceleration);
    const v_num_spatial_waypoints = this.spatial_waypoints.length;
    encoder.encode_int32_t(v_num_spatial_waypoints);
    for (let i0 = 0; i0 < v_num_spatial_waypoints; i0++) {
      this.spatial_waypoints[i0]!.encode_one(encoder);
    }
  }

  constructor(init?: {creation_utime?: int64_t, sample_utime?: int64_t, position_aggressiveness?: float, velocity_aggressiveness?: float, max_acceleration?: float, spatial_waypoints?: movement_waypoint_t[] }) {
    super();
    this.creation_utime = 0;
    this.sample_utime = 0;
    this.position_aggressiveness = 0.0;
    this.velocity_aggressiveness = 0.0;
    this.max_acceleration = 0.0;
    this.spatial_waypoints = [];

    // optionally override default values
    if (!init) {
      return;
    }
    this.creation_utime = init.creation_utime || this.creation_utime;
    this.sample_utime = init.sample_utime || this.sample_utime;
    this.position_aggressiveness = init.position_aggressiveness || this.position_aggressiveness;
    this.velocity_aggressiveness = init.velocity_aggressiveness || this.velocity_aggressiveness;
    this.max_acceleration = init.max_acceleration || this.max_acceleration;
    this.spatial_waypoints = init.spatial_waypoints || this.spatial_waypoints;
  }
}